import { Component, ViewEncapsulation,  OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerDto } from '@dto/customerDto';
import { UserDto } from '@dto/userDto';
import { Customer } from '@models/customer';
import { User } from '@models/identity/user';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { UsersService } from '@services/entity/users.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-customer',
  templateUrl: './change-customer.component.html',
  styleUrls: ['./change-customer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #292b2c;
      color: white;
    }
    .dark-modal .close {
      color: white;
    }
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
  `]
})
export class ChangeCustomerComponent implements OnInit {

  public user: UserDto;
  public customers: CustomerDto[];
  public hasMultiple: boolean = false;
  public isSupporter: boolean = false;


  constructor(
    private usersService: UsersService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
    this.usersService.getLoggedInUser().subscribe(result => {
      this.user = result;
      this.getCustomers();
    }, error => { })

    this.usersService.getCustomersOfCurrentUser().subscribe(result => {
      this.customers = result;
    }, error => { })
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }

  getCustomers() {
    this.usersService.getCustomersOfCurrentUser().subscribe(result => {
      this.customers = result;
      this.hasMultiple = this.hasMultipleAccounts();
    }, error => { })
  }

  hasMultipleAccounts() {
    if (this.customers.length >= 2) {
      return true;
    } else {
      return false;
    }
  }

  async changeCustomer(selectedCustomer: Customer) {
    this.spinner.show();
    await this.usersService.changeSelectedCustomerOfCurrentUserAsync(selectedCustomer.id);
    this.authenticationService.refreshToken().subscribe(result => {
      this.router.navigate(['/']).then(result => {
        window.location.reload();
        this.spinner.hide();
      });
    })
  }
}
